﻿import Vue from 'vue';

Vue.directive('autocomplete-remove-name', {
    bind(el, binding, vnode) {
        const vm = vnode.data.attrs.name;
        const inputs = Array.from(el.querySelectorAll(`input[name="${vm}"`));
        const notHidden = inputs.filter(i => i.type !== 'hidden');

        notHidden.forEach(i => {
            i.removeAttribute('name');
        });
    }
});